import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Typography } from '@mui/material';

import { Stack } from '@mui/system';

interface TimerProps {
  elapsedTime: number;
  totalTime: number;
}

dayjs.extend(duration);

export const Timer = ({ elapsedTime, totalTime }: TimerProps) => {
  const formattedElapsedTime = dayjs.duration(elapsedTime, 'seconds').format('mm:ss');
  const formattedTotalTime = dayjs.duration(totalTime, 'seconds').format('mm:ss');

  return (
    <Stack direction="row" spacing={2} alignItems="center" divider={<span>/</span>}>
      <Typography variant="body2">{formattedElapsedTime}</Typography>
      <Typography variant="body2">{formattedTotalTime}</Typography>
    </Stack>
  );
};
